import React from 'react'
import IconButton from '@mui/material/IconButton'
import ChevronRightRounded from '@mui/icons-material/ChevronRightRounded'
import { alpha } from '@mui/material/styles'
import { CONTROL_RADIUS } from '../detailControls'

// S459 — Workflow tenía SU chevron (cuadrado, con borde, 44×44 — el mínimo táctil de §2.5) y
// Progress tenía OTRO control (una franja sombreada con `ExpandMoreRounded`) para la MISMA acción:
// desplegar el detalle de una fila. Dos aspectos para una sola intención es justo lo que RN35 no
// tolera en un estado: aquí no es un estado, pero la lección es la misma — un control que hace lo
// mismo en dos tablas tiene que VERSE igual en las dos, o el usuario aprende dos veces la misma
// cosa. Este componente es EL botón, único, del que las dos filas tiran.
//
// ⚠️ El icono es `ChevronRightRounded`, el de Workflow — no el de Progress —, porque el PO pidió
// «el mismo botón que Workflow»: Progress adopta su aspecto, no al revés. El cambio al expandir es
// una ROTACIÓN de 90°, la misma transformación que ya tenía Workflow (nunca un icono distinto).
const ExpandRowButton = ({ testId, ariaLabel, title = '', expanded = false, onClick = () => {} }) => (
  <IconButton
    data-testid={testId}
    onClick={onClick}
    aria-label={ariaLabel}
    aria-expanded={expanded}
    title={title || ariaLabel}
    sx={(theme) => ({ width: 44, height: 44, borderRadius: CONTROL_RADIUS, border: `1px solid ${alpha(theme.palette.text.primary, 0.14)}`, color: 'text.secondary' })}
  >
    <ChevronRightRounded
      fontSize='small'
      sx={{ transform: expanded ? 'rotate(90deg)' : 'none', transition: 'transform 120ms' }}
    />
  </IconButton>
)

export default ExpandRowButton
